// extracted by mini-css-extract-plugin
export default {"headline":"blog_headline__+2bww","headlineSummary":"blog_headlineSummary__CZSr6","headlineMeta":"blog_headlineMeta__+A3qr"};